import { palette } from "./tokens";

/**
 * The OR pill from the mark, as a DOM element.
 *
 * The logo draws this in SVG because it has to rasterise as a favicon; this is
 * the same object at screen scale, kept visually identical — cream fill, dark
 * ink, tight uppercase tracking, the same slight counter-rotation.
 *
 * Its job is the same in both places: it sits on the seam and reads as the
 * hinge between the two options rather than a label on top of them.
 *
 * Sized by `size` rather than fixed, because it has to hold its own against a
 * full-screen card and also sit inside a 16px favicon. Padding and shadow are
 * derived from it so the proportions stay right at any scale — in the mark the
 * badge is roughly a third of the width, and it should read that confidently
 * here too.
 */
export const OrPill = ({
  size = 26,
  className,
}: {
  size?: number;
  className?: string;
}) => (
  <span
    aria-hidden="true"
    className={`pointer-events-none select-none rounded-full font-bold uppercase leading-none tracking-[0.04em] ${className ?? ""}`}
    style={{
      fontSize: size,
      padding: `${size * 0.34}px ${size * 0.72}px ${size * 0.38}px`,
      backgroundColor: palette.ink,
      color: palette.bg,
      transform: "rotate(-8deg)",
      // Lifts it off the two fields so the seam reads as passing behind it.
      boxShadow: `0 ${size * 0.12}px ${size * 0.5}px ${palette.bg}59`,
    }}
  >
    or
  </span>
);
